import {useEffect, useRef} from 'react';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {useCustomerMgr, useLocalesMgr} from 'coreHooks';
import Customer from 'coreClasses/customer/Customer';
import {getConfig} from 'coreUtils/utils';

export default () => {
	const {managerRepository} = useGeneralProvider();
	const customerMgr = useCustomerMgr();
	const localesMgr = useLocalesMgr();
	const customer: Customer = customerMgr.getCurrentCustomer();
	const currentLocale = localesMgr.getCurrentLocale();
	const currentLocaleCode = currentLocale.getCode();
	const previousLocaleCode = useRef(currentLocaleCode);
	const currentCountryCode = currentLocale.getCountryCode();
	const previousCountryCode = useRef(currentCountryCode);

	useEffect(() => {
		const hasLocaleChanged = currentLocaleCode !== previousLocaleCode.current;

		if (hasLocaleChanged && customerMgr.isContextAvailable() && customer.isReady()) {
			const appConfig = getConfig();
			const isCookieProcessed = localesMgr.isCookiesProcessed();
			const currentCountry = managerRepository.getCountriesMgr().getCountryByCode(currentCountryCode);
			const previousCountry = managerRepository.getCountriesMgr().getCountryByCode(previousCountryCode.current);
			const currentSiteId = currentCountry?.getSiteId();
			const previousSiteId = previousCountry?.getSiteId();

			if (
				isCookieProcessed
				&& appConfig.app.preferences.redirectToHomeOnSiteChange
				&& previousSiteId
				&& currentSiteId
				&& previousSiteId !== currentSiteId
			) {
				localesMgr.lockUrlUpdate(false);
				localesMgr.updateUrl('/', false);
			} else if (!localesMgr.isUrlUpdateLocked()) {
				localesMgr.updateUrl();
			}

			previousCountryCode.current = currentCountryCode;
			previousLocaleCode.current = currentLocaleCode;
		}
	}, [
		currentLocaleCode,
		customerMgr.isContextAvailable(),
		customer.isReady()
	]);
};